/*
 * Copyright (c) Nexign, JSC, 2020-2025.
 */
/**
 * The styled components for the widget Search Accounts
 *
 * @author Nikolay Sviridov
 * @version 1.34.0
 * @since 1.34.0
 */

import { Button } from '@nexign/scc-ui-kit';
import styled from 'styled-components';

import { ONBOARDING_DATA_ATTR } from '@/main/modules/onboarding/onboardingConstants';
import { EOnboardingComponentsId } from '@/main/modules/onboarding/types/onboardingTypes';
import { colors } from '@/main/theme';

export const RoamSubscribersPlateContainer = styled.div.attrs({
    [ONBOARDING_DATA_ATTR]: EOnboardingComponentsId.subscribersInRoaming,
})`
    margin-bottom: 10px;
`

export const RoamSubscribersContainerStyled = styled.div.attrs({
    'data-module': 'subscribersInRoaming',
})`
    width: 100%;
    height: 68px;
    position: relative;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: ${colors.accountSelectDisplayBgColorDefault};
    padding: 11px 20px 11px 20px;
    cursor: pointer;
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.09);
    border-radius: 12px;
`;

export const RoamSubscribersControlsStyled = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 32px;
`;

export const RoamSubscribersElementStyled = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 6px;
    max-width: 500px;
`;

export const FastActionButtonStyled = styled(Button)`
    gap: 6px;
`;

export const IconButtonContainer = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: center;
    cursor: pointer;
    height: 100%;
`;
